import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import HomePage from './pages/home/HomePage';
import BrandSite from './pages/brand/BrandSite';
import BrandAdminLogin from './pages/brand/BrandAdminLogin';
import BrandAdminPanel from './pages/brand/BrandAdminPanel';
import SuperAdminLogin from './pages/super/SuperAdminLogin';
import SuperAdminPanel from './pages/super/SuperAdminPanel';
import SubdomainRedirect from './components/SubdomainRedirect';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-right" toastOptions={{ duration: 3000, style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' } }} />
          <SubdomainRedirect />
          <Routes>
            {/* Homepage */}
            <Route path="/" element={<HomePage />} />

            {/* Super Admin */}
            <Route path="/superadmin/login" element={<SuperAdminLogin />} />
            <Route path="/superadmin" element={<SuperAdminPanel />} />

            {/* Brand routes */}
            <Route path="/:slug" element={<BrandSite />} />
            <Route path="/:slug/admin/login" element={<BrandAdminLogin />} />
            <Route path="/:slug/admin" element={<BrandAdminPanel />} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
